import { useState } from 'react';

import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import documentApi from 'api/document.api';
import { File } from 'providers';

type UseUploadDocumentType = {
  isLoading: boolean;
  uploadDocument: (e: any) => void;
};

export const useUploadDocument = (handleUpdateDocument: (file: File) => void): UseUploadDocumentType => {
  const [isLoading, setIsLoading] = useState(false);
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  const uploadDocument = async (e: any) => {
    const file = e.target?.files[0];
    setIsLoading(true);
    try {
      const requestIdPayload: any = await documentApi.uploadDocument(companyId, file);
      // documentApi.uploadDocument swallows failures and resolves to undefined, so guard
      // the result rather than dereferencing it. Previously a failed upload threw
      // "Cannot read properties of undefined (reading 'id')" and the file silently vanished.
      if (!requestIdPayload?.id) {
        throw new Error('Document upload did not return an id');
      }
      handleUpdateDocument({ fileName: file.name, id: requestIdPayload.id, type: 'FILE' });
    } catch (error) {
      console.error(error);
      showToast({
        title: 'Upload failed',
        description: 'Could not upload this file. Please try again.',
        status: 'error',
      });
    }
    setIsLoading(false);
  };

  return { isLoading, uploadDocument };
};
